"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitPaymentCardCms = void 0;
var SplitPaymentCardCms = /** @class */ (function () {
    function SplitPaymentCardCms() {
        this.firstCardLabel = 'First payment method';
        this.amtOnFirstCardLabel = 'Amount of first payment';
        this.amtOnFirstCardTextBoxPlaceHolderTxt = '0.00';
        this.amtOnSecondCardLabel = 'Amount of second payment';
        this.firstCardCTABtnTxt = 'Add first card';
        this.secondCardLabel = 'Second payment method';
        this.amtOnSecondCardPreFillLabel = 'Amount on second card: [[0]]';
        this.collapsedLabel = 'Pay with [[0]]';
        this.editLabel = 'Edit';
        this.invalidAmountErrorLabel = 'Amount cannot be Zero/Empty or more than duetoday (TODO: not final version)';
    }
    return SplitPaymentCardCms;
}());
exports.SplitPaymentCardCms = SplitPaymentCardCms;
//# sourceMappingURL=SplitPaymentCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/SplitPaymentCard/SplitPaymentCard.cms.js
// module id = 971
// module chunks = 8